export const convertToUTCDateInputFormat = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return ""; // Handle invalid dates
    const year = date.getUTCFullYear(); // Use UTC methods
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Month is zero-indexed
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

export const normalizeDate = (date) => {
    const normalized = new Date(date);
    normalized.setHours(0, 0, 0, 0); // Set time to 00:00:00.000
    return normalized;
};

export const convertToDateTimeInputFormat = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return ""; // Handle invalid dates
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-indexed
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};
export const convertToUTCDateTimeInputFormat = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return ""; // Handle invalid dates

    // Extract the parts of the date and time
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const day = String(date.getUTCDate()).padStart(2, "0");
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");

    // Format for <input type="datetime-local">
    return `${year}-${month}-${day} ${hours}:${minutes}`;
};
export const convertToUTCDateTimeRangeFormat = (dateString) => {
    const locale = localStorage.getItem("i18nextLng") === "en" ? "en" : "zh-CN";
    const date = new Date(dateString);
    if (isNaN(date)) return ""; // Handle invalid dates

    // Function to format a date in UTC
    const formatDateUTC = (dateObj, locale) => {
        return new Intl.DateTimeFormat(locale, {
            // weekday: "long",
            month: "short",
            day: "2-digit",
            year: "numeric",
            timeZone: "UTC",
        }).format(dateObj);
    };

    // Function to format time in UTC (12-hour AM/PM format)
    const formatTimeUTC = (dateObj, locale) => {
        return new Intl.DateTimeFormat(locale, {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
            timeZone: "UTC",
        }).format(dateObj);
    };

    // Original time in UTC
    const startTime = formatTimeUTC(date, locale);
    const startDate = formatDateUTC(date, locale);

    // Add 1 hour in UTC
    const endDateObj = new Date(date.getTime() + 60 * 60 * 1000);
    const endTime = formatTimeUTC(endDateObj, locale);
    const endDate = formatDateUTC(endDateObj, locale);

    // Check if the date has changed
    if (startDate !== endDate) {
        return (
            <>
                {startDate} <br />
                ({startTime}) <br />
                - <br />
                {endDate}<br />
                ({endTime})
            </>
        ); 
    }

    return (
        <>
            {startDate} <br />
            ({startTime} - {endTime})
        </>
    );
};

export const convertToUTCDateTimeDisplayFormat = (dateString) => {
    const locale = localStorage.getItem("i18nextLng") === "en" ? "en" : "zh-CN";
    const date = new Date(dateString);
    if (isNaN(date)) return ""; // Handle invalid dates

    // Function to format a date in UTC
    const formatDateUTC = (dateObj, locale) => {
        return new Intl.DateTimeFormat(locale, {
            // weekday: "long",
            month: "short",
            day: "2-digit",
            year: "numeric",
            timeZone: "UTC",
        }).format(dateObj);
    };

    // Function to format time in UTC (12-hour AM/PM format)
    const formatTimeUTC = (dateObj, locale) => {
        return new Intl.DateTimeFormat(locale, {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
            timeZone: "UTC",
        }).format(dateObj);
    };

    // Original time in UTC
    const startTime = formatTimeUTC(date, locale);
    const startDate = formatDateUTC(date, locale);
    return (
        <>
            {startDate} ({startTime})
        </>
    );
};

export const convertToSubcurrency = (amount, factor = 100) => {
    return Math.round(amount * factor);
}
